"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var React = __importStar(require("react"));
var header__deskop_menu_bar_1 = __importDefault(require("./header--deskop-menu-bar"));
var header__deskop_top_1 = __importDefault(require("./header--deskop-top"));
var header_mobile_1 = __importDefault(require("./header-mobile"));
var header_style_1 = __importDefault(require("./header.style"));
exports.Header = function (props) {
    var _a = React.useState(!!props.__menuMobileOpen), menuMobile = _a[0], setMenuMobile = _a[1];
    var _b = React.useState(!!props.__openUserMenuInfo), openUserMenuInfo = _b[0], setOpenUserMenuInfo = _b[1];
    var toggleMenuMobile = function () { return setMenuMobile(!menuMobile); };
    var closeUserMenuInfo = function () { return setOpenUserMenuInfo(false); };
    var toggleUserMenuInfo = function () { return setOpenUserMenuInfo(!openUserMenuInfo); };
    var sharedProps = __assign(__assign({}, props), { menuMobile: menuMobile,
        openUserMenuInfo: openUserMenuInfo,
        toggleMenuMobile: toggleMenuMobile,
        closeUserMenuInfo: closeUserMenuInfo,
        toggleUserMenuInfo: toggleUserMenuInfo });
    return (React.createElement(header_style_1.default, null,
        React.createElement("div", { className: "ds-header-mobile-space" }),
        React.createElement("div", { className: "ds-header " + (menuMobile ? 'ds-menu-mobile-opened' : '') },
            React.createElement(header__deskop_top_1.default, __assign({}, sharedProps)),
            React.createElement(header__deskop_menu_bar_1.default, __assign({}, props)),
            React.createElement(header_mobile_1.default, __assign({}, sharedProps)))));
};
//# sourceMappingURL=header.js.map